import React from "react";
import "../../styles/lab/seances.css";

/**
 * Salle déjà occupée sur certaines séances : le serveur le signale (clé
 * `conflit_salle`) sans trancher. On peut changer de salle, ou maintenir —
 * deux groupes réunis dans la même salle pour un cours commun. Maintenir
 * renvoie l'enregistrement avec `salle_partagee: true`.
 */
export default function ConflitSalle({ messages, onChanger, onMaintenir, enCours, libelleChanger = "Changer de salle" }) {
  if (!messages?.length) return null;
  return (
    <div className="conflit-salle" role="alert">
      <div className="conflit-salle-titre">
        <i className="fa-solid fa-triangle-exclamation"></i> Salle déjà occupée
      </div>
      <ul>
        {messages.map((m) => <li key={m}>{m}</li>)}
      </ul>
      <p>Choisissez une autre salle, ou maintenez si les deux groupes partagent volontairement la salle.</p>
      <div className="conflit-salle-actions">
        <button type="button" className="conflit-salle-changer" onClick={onChanger} disabled={enCours}>
          {libelleChanger}
        </button>
        <button type="button" className="conflit-salle-maintenir" onClick={onMaintenir} disabled={enCours}>
          {enCours ? "Enregistrement…" : "Maintenir dans cette salle"}
        </button>
      </div>
    </div>
  );
}
